import api from './api';

export const contactService = {
  // Submit contact form
  submitContact: (contactData) => api.post('/contact/submit', contactData),

  // Admin functions
  getAllContacts: (params) => api.get('/contact/admin/all', { params }),
  getContactById: (id) => api.get(`/contact/admin/${id}`),
  updateContactStatus: (id, statusData) => api.put(`/contact/admin/${id}/status`, statusData),
  deleteContact: (id) => api.delete(`/contact/admin/${id}`),
  getContactStats: () => api.get('/contact/admin/stats'),
};
